/**
 * @generated SignedSource<<f86d22bb4aee41d53cd6a17a177f9507>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OverviewMetricsContainerFragment$data = {
  readonly metrics: {
    readonly delegatedSupply: {
      readonly amount: string;
      readonly " $fragmentSpreads": FragmentRefs<"TokenAmountDisplayFragment">;
    };
    readonly quorum: {
      readonly amount: {
        readonly " $fragmentSpreads": FragmentRefs<"TokenAmountDisplayFragment">;
      };
    };
    readonly totalSupply: {
      readonly amount: string;
      readonly " $fragmentSpreads": FragmentRefs<"TokenAmountDisplayFragment">;
    };
  };
  readonly " $fragmentType": "OverviewMetricsContainerFragment";
};
export type OverviewMetricsContainerFragment$key = {
  readonly " $data"?: OverviewMetricsContainerFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"OverviewMetricsContainerFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TokenAmountDisplayFragment"
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OverviewMetricsContainerFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Metrics",
      "kind": "LinkedField",
      "name": "metrics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TokenAmount",
          "kind": "LinkedField",
          "name": "delegatedSupply",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TokenAmount",
          "kind": "LinkedField",
          "name": "totalSupply",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "VotingPower",
          "kind": "LinkedField",
          "name": "quorum",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TokenAmount",
              "kind": "LinkedField",
              "name": "amount",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "4e2e59844a604ebbfbc484aa3d445fdc";

export default node;
